import { Control } from "leaflet";

const FlowMapLegendControl = new Control({ position: "bottomright" });

export default FlowMapLegendControl;
